const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectorLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 82.7656,
    height: 13.0019,
    viewBox: "0 0 82.7656 13.0019",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M0.882806 5.61815H0V7.38376H0.882806V6.50095V5.61815ZM82.507 7.12519C82.8518 6.78043 82.8518 6.22147 82.507 5.87671L76.8889 0.258568C76.5441 -0.0861893 75.9852 -0.0861893 75.6404 0.258568C75.2957 0.603326 75.2957 1.16229 75.6404 1.50705L80.6343 6.50095L75.6404 11.4949C75.2957 11.8396 75.2957 12.3986 75.6404 12.7433C75.9852 13.0881 76.5441 13.0881 76.8889 12.7433L82.507 7.12519ZM0.882806 6.50095V7.38376H4.25781V6.50095V5.61815H0.882806V6.50095ZM11.0078 6.50095V7.38376H17.7578V6.50095V5.61815H11.0078V6.50095ZM24.5078 6.50095V7.38376H31.2578V6.50095V5.61815H24.5078V6.50095ZM38.0078 6.50095V7.38376H44.7578V6.50095V5.61815H38.0078V6.50095ZM51.5078 6.50095V7.38376H58.2578V6.50095V5.61815H51.5078V6.50095ZM65.0078 6.50095V7.38376H71.7578V6.50095V5.61815H65.0078V6.50095ZM78.5078 6.50095V7.38376H81.8828V6.50095V5.61815H78.5078V6.50095Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectorLine);
export default __webpack_public_path__ + "static/media/connector-line.2a30b526437b1cb0fa83d10591a88b28.svg";
export { ForwardRef as ReactComponent };